<template>
  <div class="toplevel-container">
    <div style="display: flex">
      <div v-for="root in rootItems">
        <ItemList v-for="item in root.getChildren()" :itemID="item._id" :key="item._id" />
      </div>
      <ItemList :itemID="defaultList" />
    </div>
  </div>
</template>

<style scoped>
.item-list {
  width: 200px;
  min-width: 200px;
}
.toplevel-container {
  position: fixed;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  background-color: #e5e5e5;
}

.item-list {
  width: 200px;
}
</style>

<script>
import ItemList from "@/components/ItemList.vue";
import { getItem } from "@/reactive-cache";
import { CONTAINER_TYPES, REL_ELEM, defaultContainerID } from "@/structure";
import testDocs from "@/testData";

export default {
  data() {
    return {};
  },
  components: { ItemList },
  computed: {
    rootItems() {
      return CONTAINER_TYPES.map((t) => getItem(`root:${t}`));
    },
    defaultList() {
      return defaultContainerID(REL_ELEM);
    },
  },
  methods: {
    async uploadTestData() {
      try {
        await window.pouch.get(testDocs[0]._id);
      } catch (e) {
        if (e) {
          console.log("uploading test data");
          for (const doc of testDocs) {
            window.pouch.put(doc);
          }
        }
      }
    },
  },
  mounted() {
    this.uploadTestData();
  },
};

window.dumpData = async function () {
  const resp = await window.pouch.allDocs({ include_docs: true });
  const docs = resp.rows.map((row) => row.doc);
  console.log(JSON.stringify(docs, null, 2));
};
</script>
